var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.345 0.5H10.655C10.8198 0.500035 10.9809 0.548928 11.1179 0.640498C11.2549 0.732069 11.3617 0.862205 11.4247 1.01445C11.4878 1.1667 11.5043 1.33423 11.4722 1.49586C11.44 1.65749 11.3607 1.80596 11.2442 1.9225L6.58916 6.5775C6.43289 6.73373 6.22097 6.82149 6 6.82149C5.77903 6.82149 5.5671 6.73373 5.41083 6.5775L0.75583 1.9225C0.639322 1.80596 0.559983 1.65749 0.527844 1.49586C0.495704 1.33423 0.512207 1.1667 0.575265 1.01445C0.638324 0.862205 0.745106 0.732069 0.882115 0.640498C1.01912 0.548928 1.1802 0.500035 1.345 0.5Z",
    fill: "rgba(245, 119, 2, 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdown);
export default __webpack_public_path__ + "static/media/ic-dropdown.8f7f0eb5dc1616fb2aa7cba4961102f8.svg";
export { ForwardRef as ReactComponent };